module.exports = __webpack_public_path__ + "img/Interest-swordboat--active.88e94821.svg";